import { useState, useEffect } from 'react';
import camelCase from 'lodash/camelCase';
// import get from 'lodash/get';
import zipObject from 'lodash/zipObject';
import slice from 'lodash/slice';

const buildURLQuery = query =>
  Object.entries(query)
    .map(pair => pair.map(encodeURIComponent).join('='))
    .join('&');

const zipAttributes = attributes =>
  zipObject(
    attributes.map(attribute => camelCase(attribute.attribute_code)),
    attributes.map(attribute => attribute.value)
  );

const useFetchCategory = (
  storeId,
  categoryId,
  page = 0,
  pageSize = 4,
  ignoreFirstPage = true
) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const result = data
    ? {
        items: slice(
          data.product_children,
          page * pageSize,
          page * pageSize + pageSize
        ).map(product => ({
          ...product,
          attributes: zipAttributes(product.custom_attributes),
          media: product.media_gallery_entries
        })),
        totalCount: data.product_children.length,
        page
      }
    : null;

  const query = {
    id: categoryId,
    depth: 2,
    vertical: process.env.RAZZLE_CMS_SITE
  };

  const fetchOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  };

  const baseUrl = `${process.env.RAZZLE_MAGENTO_URL}/rest/${storeId}/V1`;

  async function fetchData() {
    if (!data) {
      // endpoint does not support pagination, so we fetch everything and cache it in 'data'
      setLoading(true);
      const response = await fetch(
        `${baseUrl}/storefront/getcategorybyid?${buildURLQuery(query)}`,
        fetchOptions
      );
      const json = await response.json();
      setLoading(false);
      setData(json);
    }
  }

  useEffect(
    () => {
      if (ignoreFirstPage && page === 0) {
        setLoading(false);
        return;
      }
      if (storeId && categoryId) {
        fetchData();
      } else {
        setLoading(false);
      }
    },
    [storeId, categoryId, page, pageSize, ignoreFirstPage]
  );

  return { loading, result };
};

export default useFetchCategory;
